import { RESOURCE_NAME } from '@esentai/core/features/salesTurnovers/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadSalesTurnovers = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateSalesTurnovers = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateSalesTurnovers = authorizeIf(canUpdate(RESOURCE_NAME));
